<template functional>
  <section class="about-us-banner relative text-center">
    <div class="page-container">
      <div class="about-us-banner__title">
        <span>72% of&nbsp;sales reps</span>
        are&nbsp;frustrated at&nbsp;their current job
      </div>

      <p class="about-us-banner__subtitle">
        Tired of&nbsp;unrealistic quotas, inflated OTEs or&nbsp;selling a&nbsp;product that can&rsquo;t compete?
        <br />
        Salespeople have gotten a&nbsp;raw deal. Bravado is&nbsp;here to&nbsp;change that.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutUsBanner',
  functional: true,
};
</script>

<style lang="scss" scoped>
.about-us-banner {
  padding: 95px 0 40px;
  z-index: 1;

  @include mq('md') {
    padding: 160px 0 116px;
  }

  &__title {
    max-width: 700px;
    margin: 0 auto 21px;
    font-weight: 700;
    font-size: 33px;
    line-height: 40px;
    letter-spacing: -0.03em;
    color: var(--gray-20);

    span {
      background: linear-gradient(90.58deg, var(--theme-purple_hc_1) 14.56%, #7b61ff 90.99%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      //background-clip: text;
      //text-fill-color: transparent;
    }

    @include mq('md') {
      font-size: 64px;
      line-height: 110%;
    }
  }

  &__subtitle {
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: var(--gray-20);
    max-width: 85%;
    margin: 0 auto;

    @include mq('md') {
      font-size: 20px;
      line-height: 35px;
    }
  }
}
</style>
